import { useRouter } from "next/router";
import { NEXT_FRONTEND_URL } from "@/src/lib/util/config";
import CustomChip from "@/src/lib/ui/customChip";

const ChipBlog = ({ tag }) => {
    const router = useRouter();

    const handleClick = (e) => {
        e.stopPropagation();
        router.push(`${NEXT_FRONTEND_URL}specialization/${tag?.urlSlug}`);
    };

    return (
        <CustomChip
            onClick={handleClick}
            label={tag.specializationName}
            className="hover:bg-gray-600 hover:text-white mr-2 mb-2"
            variant="outlined"
            size="small"
        />
    );
};

export default ChipBlog;
